import { useEffect, useState } from 'react';

/**
 * Keyboard inset for the composer.
 *
 * `window.innerHeight` does not shrink when the iOS/Android keyboard opens —
 * the visual viewport does, so the chat input used to end up underneath it.
 * JitsLab handles this in `SessionLog` the same way; Pear had no
 * `visualViewport` usage anywhere.
 *
 * Returns px the app should be padded/translated up by.
 */
export function useKeyboardInset(): number {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;

    const update = () => {
      const hidden = window.innerHeight - vv.height - vv.offsetTop;
      // Ignore small deltas (browser chrome collapsing) to stop it jittering.
      setInset(hidden > 80 ? Math.round(hidden) : 0);
    };

    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);

  return inset;
}
